import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('button::-moz-focus-inner', {
    border: 0,
});

cssRule('button, input, select, textarea', {
    fontFamily: 'inherit',
});

cssRule('button', {
    fontWeight: 'normal',
});

cssRule('button::-moz-focus-inner', {
    outline: 0,
    border: 0,
});

cssRule('.tb-app', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    fontWeight: 'normal',
    fontSize: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    lineHeight: '1.5em',
});

cssRule('.tb-main-constrained', {
    minWidth: '768px',
    minHeight: '560px',
    overflow: 'hidden',
});


cssRule('.tb-app-inner', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'auto',
});

cssRule('.tb-app-inner .tb-bottom, .tb-app-inner .tb-main-content', {
    zIndex: 0,
});

cssRule('.tb-backdrop', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=33)\'',
    filter: 'alpha(opacity=33)',
    opacity: 0.33,
});

cssRule('.tb-backdrop.tb-backdrop-dark', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.inverse.default, '#000'),
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=75)\'',
    filter: 'alpha(opacity=75)',
    opacity: 0.75,
});

cssRule('.tb-backdrop-white', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    '-ms-filter': '\'progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\'',
    filter: 'alpha(opacity=50)',
    opacity: 0.5,
});

cssRule('.sr-only', {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
});

cssRule('[id*="-space-tabs-tab"]', {
    flexShrink: 0,
});

// WCAG 1.4.10 Reflow (W-21956339, W-21956331, W-21956335): the 768px
// minWidth on .tb-main-constrained above forces a horizontal page-level
// scrollbar at 400% zoom (~320 CSS px viewport), which stacks with the
// data grid's own horizontal scrollbar so users have to scroll twice to
// see all content.
//
// Below the 768px breakpoint (the same threshold at which the left
// navigation panel hides itself in NavigationStyles), do three things:
//
//   1. Drop tb-main-constrained's minWidth so the page-shell can shrink
//      to the viewport instead of forcing the body to 768px.
//   2. Force tb-app-inner to clip horizontally instead of scrolling.
//      Without this, individual descendants that have their own
//      explicit widths (e.g. the data grid library's row container,
//      whose width is set inline to the sum of column widths — see
//      @tableau/widgets-datagrid Body.tsx) would still overflow up to
//      tb-app-inner and produce a second horizontal scrollbar at the
//      page level.
//   3. Force .tb-main-content to clip horizontally too. .tb-main-content
//      composes .tb-flex-fill (position.ts), which sets overflow-y:auto.
//      The CSS spec auto-promotes overflow-x to `auto` whenever
//      overflow-y is non-visible (visible+auto isn't a valid box-model
//      combination), so .tb-main-content silently picks up its own
//      horizontal scrollbar when its descendants exceed the available
//      width. At narrow viewports the page header (omnibox + help +
//      notification + avatar) is wider than the available width, which
//      was producing the second scrollbar even after fix #2 above.
//      Clipping here keeps those page-header items inside the visible
//      area; making the page header itself responsive is a separate
//      cross-team change.
//
// Internal scroll containers (e.g. the data grid's tb-react-dg-body
// with overflow:auto) keep scrolling their own overflow, so the user
// still gets at most one horizontal scrollbar — on the data grid
// itself, where reflow is genuinely impossible without redesigning
// the columns.
//
// minHeight is preserved because it gates vertical layout, which is not
// part of the 1.4.10 reflow requirement and is already handled by the
// existing app-shell vertical scrolling.
//
// IMPORTANT: this @media block must come AFTER the regular rules it
// overrides (.tb-main-constrained, .tb-app-inner). typestyle emits
// rules in source order, and the CSS cascade picks the LAST matching
// rule when specificity is equal — even for rules inside @media
// queries. Placing this block above those declarations would let the
// later regular rules win at all viewport widths and silently undo the
// fix.
cssRule('@media screen and (max-width: 768px)', {
    $nest: {
        '.tb-main-constrained': {
            minWidth: 0,
        },
        '.tb-app-inner': {
            overflowX: 'hidden',
        },
        '.tb-main-content': {
            overflowX: 'hidden',
        },
        '.tb-flex-fill': {
            overflowX: 'hidden',
        },
    },
});

